
export default {
  name: "QuadrupleBlock",
};
